import { SxProps, Theme } from '@mui/material/styles';

// Positioning for the floating school-CTA FABs — shared so the two CTAs that
// float on the same pages can't anchor at different breakpoints.
export const floatingContainerSx: SxProps<Theme> = (theme) => ({
  zIndex: 3,
  position: 'fixed',
  [theme.breakpoints.down('md')]: {
    bottom: theme.spacing(2),
    right: theme.spacing(1),
  },
  [theme.breakpoints.only('md')]: {
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
  [theme.breakpoints.only('lg')]: {
    bottom: theme.spacing(5),
    right: theme.spacing(2),
  },
  [theme.breakpoints.up('xl')]: {
    bottom: theme.spacing(5),
    right: theme.spacing(20),
  },
});

// Responsive font scale for the school-CTA buttons on Landing and Pricing.
export const schoolCtaFontSizeSx: SxProps<Theme> = {
  fontSize: { xs: '1rem', sm: '1.125rem', md: '1.5rem' },
};
